import {Component} from "@angular/core";

@Component({
  selector: 'app-brand-backgroud-component',
  templateUrl: './brand-backgroud.component.html',
  styleUrls: ['./brand-backgroud.component.scss'],
})
export class BrandBackgroudComponent {
}
